import { css } from "@emotion/react";

export const styles = {
  wrapper: css`
    border-radius: var(--border-radii-md);
    background: var(--color-background-primary);
  `,
  title: css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: var(--spacing-16);
  `,
  muted: css`
    background: var(--color-background-tertiary);
    button svg {
      --icon-fill-color: var(--color-tertiary);
    }
  `,
  child: css`
    border-top: 1px solid var(--color-border-secondary);
    padding: var(--spacing-16);
  `
};
